import type { ActiveElement, Chart, ChartEvent } from "chart.js";
import type { DriverBarData } from "./buildChartConfig";
import { renderBucketTable } from "./renderBucketTable";

type Inputs = {
  chart: Chart;
  data: DriverBarData;
  tableBodyElement: HTMLElement;
  scopeElement: HTMLElement;
  resetElement: HTMLElement;
  userPathTemplate: string;
};

// Wires click-to-drill: clicking a bar swaps the table to that bucket's full
// ranking and reveals "Show all time", which restores the original all-time table.
export function wireDrillDown({ chart, data, tableBodyElement, scopeElement, resetElement, userPathTemplate }: Inputs): void {
  const allTimeRowsHtml = tableBodyElement.innerHTML;
  const allTimeScope = scopeElement.textContent ?? "";

  chart.options.onClick = (_event: ChartEvent, elements: ActiveElement[]) => {
    const bucketTable = data.bucket_tables[elements[0]?.index];
    if (!bucketTable) return;

    renderBucketTable({ tableBodyElement, scopeElement, bucketTable, userPathTemplate });
    resetElement.classList.remove("hidden");
  };
  chart.update();

  resetElement.addEventListener("click", () => {
    tableBodyElement.innerHTML = allTimeRowsHtml;
    scopeElement.textContent = allTimeScope;
    resetElement.classList.add("hidden");
  });
}
